"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceoverPreviewToJSON = exports.VoiceoverPreviewFromJSONTyped = exports.VoiceoverPreviewFromJSON = exports.instanceOfVoiceoverPreview = void 0;
var runtime_1 = require("../runtime");
var GenerationError_1 = require("./GenerationError");
/**
 * Check if a given object implements the VoiceoverPreview interface.
 */
function instanceOfVoiceoverPreview(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfVoiceoverPreview = instanceOfVoiceoverPreview;
function VoiceoverPreviewFromJSON(json) {
    return VoiceoverPreviewFromJSONTyped(json, false);
}
exports.VoiceoverPreviewFromJSON = VoiceoverPreviewFromJSON;
function VoiceoverPreviewFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
        'defaultMixUrl': !(0, runtime_1.exists)(json, 'default_mix_url') ? undefined : json['default_mix_url'],
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (json['errors'].map(GenerationError_1.GenerationErrorFromJSON)),
    };
}
exports.VoiceoverPreviewFromJSONTyped = VoiceoverPreviewFromJSONTyped;
function VoiceoverPreviewToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'url': value.url,
        'default_mix_url': value.defaultMixUrl,
        'errors': value.errors === undefined ? undefined : (value.errors.map(GenerationError_1.GenerationErrorToJSON)),
    };
}
exports.VoiceoverPreviewToJSON = VoiceoverPreviewToJSON;
